import template from './refresh-traveller-details-popup.html';

const DIRECTIVE_NAME = RefreshTravellerDetailsPopup.DIRECTIVE_NAME = 'ktRefreshTravellerDetailsPopup';
export default function RefreshTravellerDetailsPopup() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: RefreshTravellerDetailsPopupController,
        controllerAs: '$ctrl',
        scope: {
            travellers: `=${DIRECTIVE_NAME}`,
            close: `=${DIRECTIVE_NAME}Close`,
            dismiss: `=${DIRECTIVE_NAME}Dismiss`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function RefreshTravellerDetailsPopupController() {
    'ngInject';
    const vm = this;

    Object.assign(vm, {$onInit});

    function $onInit() {
        vm.isSingleTraveller = vm.travellers.length === 1;
        vm.TravellersIds = vm.travellers.map((traveller) => traveller.Id);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/travellers/refresh-traveller-details-popup/refresh-traveller-details-popup-component.js